export class MouseMovedTag {}
export class KeyboardMovedTag {}
export class RandomWiggle {}
